export const handleTrackAndRedirect = (trackFn, page) => {
  trackFn().then(() => {
    window.location.href = page;
  });
};
